import { className } from '@/utils/classname';
import { IBillContentBlock } from './type';

interface Props {
  blockProps: IBillContentBlock;
  scaleFactor?: number;
  maxWidth: number;
  priceShow?: number;
  loopLength?: number;
  itemcode?: boolean;
  isDiscount?: boolean;
  isTenderAmt?: boolean;
}

export const BillContentBlock: React.FC<Props> = (props) => {
  const {
    blockProps,
    scaleFactor = 1,
    maxWidth,
    loopLength,
    priceShow,
    itemcode,
    isDiscount,
    isTenderAmt,
  } = props;
  const { data } = blockProps;

  return (
    <div style={{ width: maxWidth * scaleFactor, fontSize: 10 * scaleFactor }}>
      <div
        className="tw-border-t tw-border-b"
        style={{
          lineHeight: 0.9,
        }}
      >
        <div
          className={`tw-flex tw-gap-1 tw-py-1 tw-items-center tw-border-b tw-font-semibold`}
          // style={{
          //   lineHeight: 0.1,
          // }}
        >
          <div className="tw-w-[22px] tw-px-[5px] tw-text-start">S.N</div>
          <div className="tw-w-[9.5%] tw-text-start">HS Code</div>
          <div className="tw-flex-1 tw-text-start">Service</div>
          {itemcode && (
            <div className="tw-w-[12%] tw-text-start">Item Code</div>
          )}
          <div className="tw-w-[12%] tw-text-end">Rate</div>
          <div className="tw-w-[12%] tw-text-end">Qty</div>
          <div className="tw-w-[12%] tw-text-end">Amount</div>
        </div>
        {data?.items.map((item, index) => (
          <div
            key={index}
            className={className('tw-flex tw-gap-1 tw-py-1', {
              '': data?.items.length - 1 !== index,
            })}
            // style={{
            //   lineHeight: 0.1,
            // }}
          >
            <div className="tw-w-[22px] tw-px-[5px] tw-text-start">
              {item?.index + 1}
            </div>
            {/*   For HS Code */}
            <div className="tw-w-[9.5%] tw-text-start tw-text-wrap"></div>
            <div className="tw-flex-1 tw-text-start tw-text-wrap">
              {item.service}
            </div>
            <div className="tw-w-[12%] tw-text-start">{item.item_code}</div>
            <div className="tw-w-[12%] tw-text-end">{item.rate}</div>
            <div className="tw-w-[12%] tw-text-end">{item.quantity}</div>
            <div className="tw-w-[12%] tw-text-end">{item.amount}</div>
          </div>
        ))}
      </div>
      {priceShow === (loopLength ?? 0) - 1 ? (
        <div>
          <div className="tw-flex tw-justify-between tw-gap-5 tw-my-1">
            <div className="tw-text-start">
              <div className="tw-text-wrap" style={{ wordBreak: 'break-word' }}>
                Remarks : {data?.remarks}
              </div>
              <div className="tw-flex tw-gap-1">
                <div> Payment Method :</div>
                <div className="tw-flex tw-justify-start tw-gap-2">
                  {data?.payment_method?.map((item: any, index: number) => (
                    <div
                      key={index + 1}
                      className="tw-flex tw-justify-start tw-gap-1"
                    >
                      {item?.pay_method} : {`Rs. ${item?.net_amount}`}
                      {`${data?.payment_method.length - 1 !== index ? ',' : ' '}`}
                      {`${item?.transaction_no ?? ''}`}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="tw-text-end">
              <div>Sub Total : {data?.sub_total?.toFixed(2)}</div>
              {isDiscount && <div>Discount : {data?.discount?.toFixed(2)}</div>}
              {isTenderAmt &&
                (data?.tender_amount ? (
                  <div>Tender Amount: {data?.tender_amount?.toFixed(2)}</div>
                ) : (
                  ''
                ))}
              {data?.due_amount ? (
                <div>Due Amount : {data?.due_amount?.toFixed(2)}</div>
              ) : (
                ''
              )}
              {data?.return_amount ? (
                <div>Return Amount : {data?.return_amount?.toFixed(2)}</div>
              ) : (
                ''
              )}
            </div>
          </div>

          <div className="tw-flex tw-flex-row tw-text-start tw-justify-between tw-gap-x-1 tw-border-t tw-border-b tw-w-full">
            <div className="tw-break-words tw-text-wrap tw-overflow-hidden">
              In Words [NPR] : {data?.amt_to_words_v}
            </div>
            <div className="tw-font-semibold tw-break-words">
              Total: {data?.total?.toFixed(2)}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
